import React from 'react';
import ApplicationForms from "../../components/Applications";

const Applications = props => {
  return(<ApplicationForms/>)
}

export default Applications;